<script lang="ts">
    import {
        dictionary,
        updateDictionary,
        updateDictionaryByCodes,
    } from "@app/services/currentDictionary.service";

    import { isMobile } from "@app/services/isMobile";
    import {
        showChangeLanguageWidget,
        toggleChangeDictionaryWidget,
    } from "./ChangeDictionary.store";
    import ChangeLanguageInline from "./Desktop/ChangeLanguageInline.svelte";
    import ChangeDictionaryWidgetLoader from "./Mobile/ChangeDictionaryWidgetLoader.svelte";
    import ChangeLanguageWidget from "./Mobile/ChangeLanguageWidget.svelte";
    import DictionaryChangesMonitor from "./Mobile/DictionaryChangesMonitor.svelte";

    const container = document.getElementById("glosbe-components");
    function installChangeDictionaryWidget() {
        if (!container) {
            return;
        }
        const changeDictionaryActivatorElements =
            document.querySelectorAll<HTMLElement>(
                'a[data-element="change-dictionary"], button[data-element="change-dictionary"]'
            );

        if (changeDictionaryActivatorElements.length === 0) {
            return;
        }
        changeDictionaryActivatorElements.forEach((activator) => {
            activator.addEventListener("click", (event: Event) => {
                event.preventDefault();
                event.stopPropagation();
                toggleChangeDictionaryWidget();
            });
        });

        new ChangeDictionaryWidgetLoader({
            target: container,
        });
    }

    function installChangeLanguageWidget() {
        if (!container) {
            return;
        }
        let changeLanguageWidget: ChangeLanguageWidget;
        [
            ...document.querySelectorAll<HTMLAnchorElement>(
                '[data-element="dictionary__source"], [data-element="dictionary__target"]'
            ),
        ].forEach((activator) => {
            const props = {
                languageType:
                    activator.dataset["element"] === "dictionary__source"
                        ? "source"
                        : "target",
                activator: activator,
            };
            if (isMobile()) {
                if (!changeLanguageWidget) {
                    changeLanguageWidget = new ChangeLanguageWidget({
                        target: container,
                    });
                }
                activator.addEventListener("click", (event: Event) => {
                    event.preventDefault();
                    showChangeLanguageWidget(
                        props.languageType === "source" ? "source" : "target"
                    );
                });
            } else {
                activator.addEventListener("click", (event: Event) => {
                    event.preventDefault();

                    let changeLanguageInlineWidget = (activator as any)
                        .changeLanguageInlineWidget;
                    if (!changeLanguageInlineWidget && activator.parentElement) {
                        changeLanguageInlineWidget = new ChangeLanguageInline({
                            target: activator.parentElement,
                            props,
                        });
                        (activator as any).changeLanguageInlineWidget =
                            changeLanguageInlineWidget;
                    }
                    setTimeout(() =>
                        changeLanguageInlineWidget.$set({ open: true })
                    );
                });
            }
        });
    }

    function installFlipLanguagesWithoutReload() {
        function flipDictionaries(event: Event) {
            event.preventDefault();
            updateDictionary({ l1: $dictionary.l2, l2: $dictionary.l1 });
            const input = document.getElementById("dictionary-search");
            if (input) {
                input.focus();
            }
        }
        Array.from(document.querySelectorAll(".languages__flip")).forEach(
            (item) => {
                item.addEventListener("click", flipDictionaries);
            }
        );
    }

    function installRecentlyUsedDictionariesShortcuts() {
        function onRecentlyUsedLanguagesItemClicked(event: Event) {
            const target = event.target as HTMLAnchorElement;
            const fromCode = target.dataset["fromCode"];
            const destCode = target.dataset["destCode"];

            if (fromCode && destCode) {
                event.preventDefault();
                updateDictionaryByCodes(fromCode, destCode);
            }
        }

        const activators = Array.from(
            document.querySelectorAll("#recently-used-dictionaries a")
        );

        activators.forEach((activator) => {
            activator.addEventListener(
                "click",
                onRecentlyUsedLanguagesItemClicked
            );
        });
    }

    installChangeDictionaryWidget();
    installChangeLanguageWidget();
    installFlipLanguagesWithoutReload();
    installRecentlyUsedDictionariesShortcuts();
</script>

<DictionaryChangesMonitor />
